<h1 class="item-page-title-field">
  <div *ngIf="item.firstMetadataValue('dspace.entity.type') as type" class="d-inline">
    {{ type.toLowerCase() + '.page.titleprefix' | translate }}
  </div>
  <div class="d-flex justify-content-between">
    <span class="dont-break-out">{{ dsoNameService.getName(item) }}</span>
  </div>
</h1>
